// --- i18n strings (6 languages) ---
const I18N = {
    'zh-CN': {
        pageTitle: "\u7F51\u7AD9\u5EFA\u8BBE\u4E2D...",
        title: "\u7F51\u7AD9\u5EFA\u8BBE\u4E2D...",
        subtitle: "\u6211\u4EEC\u6B63\u5728\u6253\u78E8\u4F53\u9A8C\uFF0C\u5F88\u5FEB\u89C1\u9762\u3002",
        infoTitle: "\u7F51\u7AD9\u5347\u7EA7\u4E2D",
        infoDesc: "\u6211\u4EEC\u6B63\u5728\u8FDB\u884C\u4F8B\u884C\u7EF4\u62A4\u4E0E\u5185\u5BB9\u66F4\u65B0\uFF0C\u4EE5\u5E26\u6765\u66F4\u987A\u6ED1\u3001\u7B80\u6D01\u4E14\u53EF\u9760\u7684\u4F53\u9A8C\u3002"
    },
    'en': {
        pageTitle: 'Under Construction',
        title: 'Website under construction...',
        subtitle: 'We\'re polishing the experience. See you soon.',
        infoTitle: 'Site Upgrade in Progress',
        infoDesc: 'Routine maintenance and content updates are underway to deliver a smoother, simpler, and more reliable experience.'
    },
    'ja': {
        pageTitle: "\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u4E2D...",
        title: "\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u306F\u73FE\u5728\u5EFA\u8A2D\u4E2D\u3067\u3059...",
        subtitle: "\u305F\u3060\u3044\u307E\u4F53\u9A13\u3092\u78E8\u3044\u3066\u3044\u307E\u3059\u3002\u307E\u3082\u306A\u304F\u516C\u958B\u3057\u307E\u3059\u3002",
        infoTitle: "\u30B5\u30A4\u30C8\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u4E2D",
        infoDesc: "\u3088\u308A\u30B9\u30E0\u30FC\u30BA\u3067\u30B7\u30F3\u30D7\u30EB\u3001\u4FE1\u983C\u3067\u304D\u308B\u4F53\u9A13\u306E\u305F\u3081\u3001\u5B9A\u671F\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u3068\u66F4\u65B0\u3092\u5B9F\u65BD\u3057\u3066\u3044\u307E\u3059\u3002"
    },
    'ko': {
        pageTitle: "\uACF5\uC0AC \uC911...",
        title: "\uC6F9\uC0AC\uC774\uD2B8 \uC81C\uC791 \uC911...",
        subtitle: "\uB354 \uB098\uC740 \uACBD\uD5D8\uC744 \uC704\uD574 \uB2E4\uB4EC\uB294 \uC911\uC785\uB2C8\uB2E4. \uACE7 \uB9CC\uB098\uC694.",
        infoTitle: "\uC0AC\uC774\uD2B8 \uC5C5\uADF8\uB808\uC774\uB4DC \uC9C4\uD589 \uC911",
        infoDesc: "\uB354 \uBD80\uB4DC\uB7FD\uACE0 \uB2E8\uC21C\uD558\uBA70 \uC2E0\uB8B0\uD560 \uC218 \uC788\uB294 \uACBD\uD5D8\uC744 \uC704\uD574 \uC815\uAE30 \uC810\uAC80\uACFC \uC5C5\uB370\uC774\uD2B8\uB97C \uC9C4\uD589\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4."
    },
    'es': {
        pageTitle: "En Construcci\xf3n...",
        title: "Sitio web en construcci\xf3n...",
        subtitle: 'Estamos puliendo la experiencia. Nos vemos pronto.',
        infoTitle: "Actualizaci\xf3n del sitio en progreso",
        infoDesc: "Mantenimiento rutinario y actualizaciones en curso para ofrecer una experiencia m\xe1s fluida, simple y confiable."
    },
    'fr': {
        pageTitle: 'En travaux...',
        title: 'Site Web en construction...',
        subtitle: "Nous peaufinons l'exp\xe9rience. \xc0 tr\xe8s vite.",
        infoTitle: "Mise \xe0 niveau du site en cours",
        infoDesc: "Maintenance et mises \xe0 jour en cours pour une exp\xe9rience plus fluide, simple et fiable."
    }
};
// Elements
const titleEl = document.getElementById('titleText');
const subEl = document.getElementById('subtitleText');
const infoTitleEl = document.getElementById('infoTitle');
const infoDescEl = document.getElementById('infoDesc');
const langBtns = document.querySelectorAll('[data-lang]');
const textContent = document.getElementById('textContent');
const infoContent = document.getElementById('infoContent');
const loadingDots = document.getElementById('loadingDots');
const pageCard = document.getElementById('pageCard');
const loadingOverlay = document.getElementById('loadingOverlay');
const themeToggle = document.getElementById('themeToggle');
// Helper: set theme
function applyTheme(theme) {
    if (theme === 'dark') {
        document.documentElement.setAttribute('data-theme', 'dark');
        themeToggle.setAttribute('aria-pressed', 'true');
        themeToggle.textContent = "\u2600\uFE0F";
    } else {
        document.documentElement.removeAttribute('data-theme');
        themeToggle.setAttribute('aria-pressed', 'false');
        themeToggle.textContent = "\uD83C\uDF19";
    }
    localStorage.setItem('uc-theme', theme);
}
// Determine initial theme: prefer saved, otherwise follow system; default 'light' if not available
(function initTheme() {
    const saved = localStorage.getItem('uc-theme');
    if (saved === 'dark' || saved === 'light') return applyTheme(saved);
    // no saved preference: follow system preference when available, else light
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    applyTheme(prefersDark ? 'dark' : 'light');
    // listen to system changes to update if user hasn't set a preference
    window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e)=>{
        const saved2 = localStorage.getItem('uc-theme');
        if (!saved2) applyTheme(e.matches ? 'dark' : 'light');
    });
})();
themeToggle.addEventListener('click', ()=>{
    const now = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    applyTheme(now);
});
// Loading overlay control
function hideLoading() {
    loadingOverlay.style.opacity = '0';
    loadingOverlay.style.pointerEvents = 'none';
    setTimeout(()=>loadingOverlay.remove(), 600);
}
// Compute a fixed min-height based on the longest localized content (so switching languages won't resize)
function computeMinHeight() {
    const isMobile = window.innerWidth <= 640;
    // 创建临时测量容器，完全复制pageCard的结构和样式
    const temp = document.createElement('div');
    temp.style.position = 'absolute';
    temp.style.left = '-9999px';
    temp.style.top = '0';
    temp.style.visibility = 'hidden';
    // 使用pageCard的实际宽度，而不是maxWidth
    const pageCardRect = pageCard.getBoundingClientRect();
    temp.style.width = pageCardRect.width + 'px';
    temp.style.padding = getComputedStyle(pageCard).padding;
    temp.style.boxSizing = 'border-box';
    temp.style.fontFamily = getComputedStyle(document.body).fontFamily;
    temp.style.fontSize = getComputedStyle(document.body).fontSize;
    temp.style.lineHeight = getComputedStyle(document.body).lineHeight;
    temp.style.borderRadius = getComputedStyle(pageCard).borderRadius;
    temp.style.display = 'flex';
    temp.style.flexDirection = 'column';
    // 复制所有相关的CSS变量
    const computedStyle = getComputedStyle(document.documentElement);
    temp.style.setProperty('--text', computedStyle.getPropertyValue('--text'));
    temp.style.setProperty('--muted', computedStyle.getPropertyValue('--muted'));
    temp.style.setProperty('--card-bg', computedStyle.getPropertyValue('--card-bg'));
    temp.style.setProperty('--glass-shadow', computedStyle.getPropertyValue('--glass-shadow'));
    document.body.appendChild(temp);
    let maxH = 0;
    let heightDetails = {}; // 记录每种语言的高度详情
    Object.keys(I18N).forEach((key)=>{
        // 使用实际的响应式字体大小
        const titleFontSize = isMobile ? '22px' : '28px';
        const subtitleFontSize = isMobile ? '14px' : '15px';
        const infoTitleFontSize = isMobile ? '15px' : '16px';
        const infoDescFontSize = isMobile ? '13px' : '14px';
        // 创建完整的pageCard结构
        temp.innerHTML = `
      <!-- Controls -->
      <div style="position:absolute; right:18px; top:18px; display:flex; gap:8px; align-items:center;">
        <button style="width:40px; height:36px; border-radius:10px; display:inline-flex; align-items:center; justify-content:center;">\u{1F319}</button>
      </div>

      <!-- Hero Section -->
      <div style="display:flex; flex-direction:column; align-items:center; gap:8px; padding:20px 12px 8px 12px; text-align:center;">
        <span style="width:72px; height:72px; border-radius:18px; display:inline-block; background:url('https://cdn.jsdelivr.net/gh/hwangzhun/Apple-style-Website-under-construction-page@main/Settings.svg') center/contain no-repeat; background-size:60%;"></span>
        <div>
          <h1 style="margin:6px 0 0; font-size:${titleFontSize}; font-weight:600; line-height:1.3">${I18N[key].title}</h1>
          <p style="margin:0; color:var(--muted); font-size:${subtitleFontSize}; line-height:1.5">${I18N[key].subtitle}</p>
        </div>
        
        <!-- Progress Bar -->
        <div style="margin-top:18px; width:100%; max-width:640px; margin-left:auto; margin-right:auto;">
          <div style="height:6px; border-radius:999px; background:linear-gradient(90deg, rgba(0, 0, 0, 0.06), rgba(0, 0, 0, 0.03)); overflow:hidden;">
            <div style="height:100%; width:50%; border-radius:999px; background:linear-gradient(90deg, #007aff, #00c6ff); transform:translateX(-100%);"></div>
          </div>
        </div>
      </div>

      <!-- Info Card -->
      <div style="margin-top:30px; border-radius:14px; padding:14px; background:transparent; display:flex; gap:12px; align-items:flex-start; box-shadow:none; justify-content:center; text-align:center;">
        <div style="flex:0 0 44px; display:flex; gap:12px; align-items:center; justify-content:center; margin-bottom:20px;">
          <div style="width:8px; height:8px; border-radius:50%; background:var(--text); opacity:0.25;"></div>
          <div style="width:8px; height:8px; border-radius:50%; background:var(--text); opacity:0.25;"></div>
          <div style="width:8px; height:8px; border-radius:50%; background:var(--text); opacity:0.25;"></div>
          <div style="width:8px; height:8px; border-radius:50%; background:var(--text); opacity:0.25;"></div>
        </div>
        <div>
          <h3 style="margin:0 0 6px; font-size:${infoTitleFontSize}; line-height:1.3">${I18N[key].infoTitle}</h3>
          <p style="margin:0; color:var(--muted); font-size:${infoDescFontSize}; line-height:1.5">${I18N[key].infoDesc}</p>
        </div>
      </div>

      <!-- Language Buttons -->
      <div style="display:flex; flex-wrap:wrap; gap:8px; justify-content:center; margin-top:auto; margin-bottom:18px;">
        <button style="border-radius:999px; padding:6px 12px; font-size:14px;">\u{4E2D}\u{6587}</button>
        <button style="border-radius:999px; padding:6px 12px; font-size:14px;">English</button>
        <button style="border-radius:999px; padding:6px 12px; font-size:14px;">\u{65E5}\u{672C}\u{8A9E}</button>
        <button style="border-radius:999px; padding:6px 12px; font-size:14px;">\u{D55C}\u{AD6D}\u{C5B4}</button>
        <button style="border-radius:999px; padding:6px 12px; font-size:14px;">Espa\xf1ol</button>
        <button style="border-radius:999px; padding:6px 12px; font-size:14px;">Fran\xe7ais</button>
      </div>

      <!-- Footer -->
      <footer style="margin-top:0; text-align:center; color:var(--muted); font-size:13px; padding-top:0;">\xa9 2025 Hwangzhun</footer>
    `;
        // 强制布局并测量
        const h = temp.getBoundingClientRect().height;
        heightDetails[key] = h;
        if (h > maxH) maxH = h;
    });
    document.body.removeChild(temp);
    // 设置计算出的最大高度
    const final = Math.ceil(maxH);
    pageCard.style.minHeight = final + 'px';
    // 输出详细的高度信息用于调试
    console.log(`=== \u{9AD8}\u{5EA6}\u{8BA1}\u{7B97}\u{5B8C}\u{6210} (${isMobile ? "\u79FB\u52A8\u7AEF" : "\u684C\u9762\u7AEF"}) ===`);
    console.log(`\u{6D4B}\u{91CF}\u{5BB9}\u{5668}\u{5BBD}\u{5EA6}: ${pageCardRect.width}px`);
    console.log(`\u{89C6}\u{53E3}\u{5BBD}\u{5EA6}: ${window.innerWidth}px`);
    console.log("\u5404\u8BED\u8A00\u9AD8\u5EA6\u8BE6\u60C5:");
    Object.entries(heightDetails).forEach(([lang, height])=>{
        console.log(`  ${lang}: ${Math.ceil(height)}px`);
    });
    console.log(`\u{6700}\u{5927}\u{9AD8}\u{5EA6}: ${final}px`);
    console.log(`\u{8BBE}\u{7F6E}\u{7684}\u{6700}\u{5C0F}\u{9AD8}\u{5EA6}: ${final}px`);
    console.log('========================');
}
// Language switch with fade animation
let langTransitioning = false;
function switchLanguage(code) {
    if (langTransitioning) return;
    langTransitioning = true;
    // find closest key (normalize)
    const key = Object.keys(I18N).includes(code) ? code : code.split('-')[0] || 'en';
    // fade out (only text content, not loading dots)
    textContent.classList.remove('fade-in');
    textContent.classList.add('fade-out');
    infoContent.classList.remove('fade-in');
    infoContent.classList.add('fade-out');
    setTimeout(()=>{
        // set texts
        titleEl.textContent = I18N[key].title;
        subEl.textContent = I18N[key].subtitle;
        infoTitleEl.textContent = I18N[key].infoTitle;
        infoDescEl.textContent = I18N[key].infoDesc;
        // update page title
        document.title = I18N[key].pageTitle;
        // fade in (only text content, not loading dots)
        textContent.classList.remove('fade-out');
        textContent.classList.add('fade-in');
        infoContent.classList.remove('fade-out');
        infoContent.classList.add('fade-in');
        // mark active pill
        document.querySelectorAll('[data-lang]').forEach((btn)=>{
            btn.classList.toggle('btn-dark', btn.getAttribute('data-lang') === key);
            btn.classList.toggle('btn-outline-secondary', btn.getAttribute('data-lang') !== key);
        });
        // store
        localStorage.setItem('uc-lang', key);
        langTransitioning = false;
    }, 260);
}
// Wire language buttons
document.querySelectorAll('[data-lang]').forEach((btn)=>{
    btn.addEventListener('click', ()=>switchLanguage(btn.getAttribute('data-lang')));
});
// init language: prefer stored, else navigator
(function initLang() {
    const saved = localStorage.getItem('uc-lang');
    if (saved && I18N[saved]) switchLanguage(saved);
    else {
        const nav = (navigator.language || navigator.userLanguage || 'en').toLowerCase();
        const find = Object.keys(I18N).find((k)=>nav.startsWith(k.split('-')[0]));
        switchLanguage(find || 'en');
    }
})();
// compute min height on load and on resize (debounced)
window.addEventListener('load', ()=>{
    computeMinHeight();
    // hide loading overlay
    setTimeout(hideLoading, 420);
});
// 优化的 resize 监听器
let resizeTimeout;
let lastWidth = window.innerWidth;
window.addEventListener('resize', ()=>{
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(()=>{
        // 只有在宽度变化时才重新计算（避免移动端滚动触发）
        if (Math.abs(window.innerWidth - lastWidth) > 10) {
            computeMinHeight();
            lastWidth = window.innerWidth;
        }
    }, 250); // 增加延迟，避免频繁触发
});
// Accessibility: allow Shift+D to toggle theme (with smooth transition)
document.addEventListener('keydown', (e)=>{
    if (e.shiftKey && e.key.toLowerCase() === 'd') {
        const now = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
        applyTheme(now);
    }
});
// small enhancement: prevent abrupt initial layout flash by computing min-height ASAP
// run once synchronously if DOM already parsed
document.addEventListener('DOMContentLoaded', ()=>{
    try {
        computeMinHeight();
    } catch (e) {}
});

//# sourceMappingURL=repo.dd783f18.js.map
